import { PdfFieldEditor } from "../components/PdfFieldEditor";

export function DestinationPacketsTemplateCreatePage() {
  return <PdfFieldEditor />;
}

